module.exports = __webpack_public_path__ + "img/shoppingBag_white.2a0e8a15.svg";